import axios from "axios";

const API_URL = "/api"; // cambia si subes a VPS

// Para mantener el token en cada request
const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = "Bearer " + token;
  return config;
});

export default {
  login: (email, password) => api.post("/auth/login", { email, password }),
  listUsers: () => api.get("/users"),
  createUser: (data) => api.post("/users", data),
  listDevices: () => api.get("/devices"),
  createDevice: (data) => api.post("/devices", data),
  assignDevice: (data) => api.post("/devices/assign", data),
  myDevices: () => api.get("/devices/my"),
  deviceOn: (deviceId) => api.post(`/control/${deviceId}/on`),
  deviceOff: (deviceId) => api.post(`/control/${deviceId}/off`),
  deviceStatus: (deviceId) => api.get(`/control/${deviceId}/status`),
};
